<template>
  <div>
    <div class="buying-select">
      <div class="buying-selectd">
        <div>选择子库：</div>
        <div :class="is_active==item.title?'is-active':''" :key="index" @click="libChange(item)" class="buying-source" v-for="(item, index) in libraryList">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="buying-payment">
      <div class="buying-seclec">
        <div>权限级别：</div>
        <el-select v-model="permLevel">
          <el-option key="READ" label="阅读" value="r"></el-option>
          <el-option key="DOWNLOAD" label="下载" value="d"></el-option>
        </el-select>
      </div>
      <div class="payment-box">
        <div :class="permice == item.permice?'is-active':''" :key="index" @click="buying(item)" class="payment-item" v-for="(item, index) in oncePrice[permLevel]">
          <div class="paymen-item-box">
            <div class="payment-item-title">
              {{ item.title }}
            </div>
            <div class="payment-item-price">
              <div class="price-f">￥</div>
              <div class="price-p" style="margin: 0 0.2rem;">{{ item.price / 100 }}</div>
              <div class="price-d" style="min-width:1.25rem;">/{{ item.day }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="buying-image">
        <div class="image-box">
          <div id="qrcodes1" ref="qrcodes1"></div>
        </div>
        <div class="title">请使用微信/支付宝扫码支付</div>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 4rem;">
        <el-button @click="paymentFinished" class="btn">支付完成</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import {purchaseSublibrary, queryPayResult} from '../../api/buying'

  export default {
    name: 'PortalSublibrary',

    data() {
      return {
        libraryList: [
          {
            title: '铸牢中华民族共同体意识古籍库',
            ref: 'zhulao'
          },
          {
            title: '中华古壮字古籍库',
            ref: 'zhonghua'
          },
          {
            title: '广西地方特色文献库',
            ref: 'guangxidi'
          },
          {
            title: '广西经典文献当代转化库',
            ref: 'guangxijing'
          },
          {
            title: '中华古壮字字典',
            ref: 'guzhuangzi'
          },
        ],
        is_active: '铸牢中华民族共同体意识古籍库',
        permLevel: 'r',
        permice: '1',
        oncePrice: {
          r: [
            {
              price: 1,
              title: '一天浏览权',
              day: '天',
              permice: '1'
            },
            {
              price: 2,
              title: '包月',
              day: '月',
              permice: '30'
            },
            {
              price: 3,
              title: '包年',
              day: '年',
              permice: '年'
            },
            {
              price: 4,
              title: '终身',
              day: '终身',
              permice: '-1'
            },
          ],
          d: [
            {
              price: 3,
              title: '一天浏览权',
              day: '天',
              permice: '1'
            },
            {
              price: 2,
              title: '包月',
              day: '月',
              permice: '30'
            },
            {
              price: 3,
              title: '包年',
              day: '年',
              permice: '年'
            },
            {
              price: 4,
              title: '终身',
              day: '终身',
              permice: '-1'
            },
          ],
          c: [
            {
              price: 1,
              title: '一天浏览权',
              day: '天',
              permice: '1'
            },
            {
              price: 2,
              title: '包月',
              day: '月',
              permice: '30'
            },
            {
              price: 3,
              title: '包年',
              day: '年',
              permice: '年'
            },
            {
              price: 4,
              title: '终身',
              day: '终身',
              permice: '-1'
            },
          ]
        }
      };
    },

    mounted() {
      this.init()
    },

    methods: {
      async libChange(item) {
        if (item.title == this.is_active) return
        this.is_active = item.title
        this.$refs.qrcodes1.innerHTML = ''
        let data = await this.chaseBooks(this.permice)
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })
      },
      async buying(item) {
        if (item.permice === this.permice) return
        this.permice = item.permice
        this.$refs.qrcodes1.innerHTML = ''
        this.permice = item.permice
        let data = await this.chaseBooks(this.permice)
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })
      },
      // 生成支付二维码
      qrcode() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let qrcode = new QRCode('qrcodes1', {
          width: 8.333 * fontSize, // 设置宽度，单位像素
          height: 8.333 * fontSize, // 设置高度，单位像素
          text: this.url // 设置二维码内容或跳转地址
        })
      },
      // 初始化
      async init() {
        let data = await this.chaseBooks(1)
        this.url = data.qrCodeUrl
        this.tradeNo = data.tradeNo
        this.$nextTick(() => {
          // 创建二维码
          this.qrcode()
        })

      },
      // 查询价格
      chaseBooks(e) {
        return new Promise((provide, inject) => {
          purchaseSublibrary({
            sublibraryName: this.is_active,
            permLevel: this.permLevel == 'r' ? 'READ' : 'DOWNLOAD',
            daysFor: e
          }).then(res => {
            if (res.data.code == 200) {
              provide(res.data.data)
            } else if (res.data.code == 400) {
              this.$message({
                message: res.data.message + '正在返回请稍后',
                type: 'error'
              })
              setTimeout(() => {
                this.$router.push({
                  path: '/resource/detail',
                  query: {
                    bookId: this.$route.query.bookId
                  }
                })
              }, 500)
            } else if (res.data.code == 10006) {
              this.$message({
                message: res.data.message,
                type: 'error'
              })
              this.$router.go(-1)
            }
          })
        })
      },
      // 查询支付是否成功
      paymentFinished() {
        queryPayResult({
          tradeNo: this.tradeNo
        }).then(res => {
          if (res.data.code == 200) {
            if (res.data.data.trxstatus === '0000') {
              this.$message({
                message: "支付成功，请稍后",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  path: '/resource/detail',
                  query: {
                    bookId: this.$route.query.bookId
                  }
                })
              }, 1000);
            } else {
              this.$message({
                message: res.data.data.desc,
                type: "error",
              });
            }
          } else if (res.data.code == 20006) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .buying-select {
    background-color: #fff;
    padding: 0 1.563rem;

    .buying-selectd {
      display: flex;
      align-items: center;
      height: 5.729rem;

      div {
        font-size: 1.146rem;
        letter-spacing: 0.021rem;
        color: #333333;
      }

      .buying-source {
        padding: 0.677rem 0.425rem 0.573rem 0.425rem;
        background-color: #ffffff;
        border-radius: 0.313rem;
        border: solid 0.052rem #cccccc;
        font-size: 0.833rem;
        letter-spacing: 0.016rem;
        color: #333333;
        margin-right: 1.563rem;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        &.is-active {
          background-color: #b1222b;
          border: solid 0.052rem #b1222b;
          color: #ffffff;
        }
      }
    }
  }

  .buying-payment {
    width: 62.5rem;
    min-height: 34.896rem;
    background-color: #ffffff;
    border-radius: 0.833rem;

    .buying-seclec {
      display: flex;
      align-items: center;
      padding-left: 1.563rem;

      div {
        font-size: 1.146rem;
        letter-spacing: 0.021rem;
        color: #333333;
      }

      /deep/ .el-select {
        width: 7.292rem;
        height: 2.083rem;

        .el-input__inner {
          text-align: center;
          height: 2.083rem;

          &:focus {
            border-color: #C0C4CC;
          }
        }
      }
    }

    .payment-box {
      display: flex;
      justify-content: space-between;
      padding: 4.167rem 4.167rem 2.064rem 4.167rem;

      .payment-item {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: calc(10.938rem);
        height: calc(13.542rem);
        background: url('../../assets/image/buying/kuang2.png') no-repeat;
        background-size: cover;

        &:hover, &.is-active {
          background: url('../../assets/image/buying/kuang1.png') no-repeat;
          background-size: cover;
          box-shadow: none;
          border: unset
        }

        .paymen-item-box {
          text-align: center;

          .payment-item-title {
            font-size: 1.146rem;
            color: #333333;
          }

          .payment-item-price {
            display: flex;
            align-items: baseline;
            justify-content: center;
            text-align: center;
            margin-top: 2.188rem;

            .price-f, .price-d {
              font-size: 0.833rem;
              color: #333333;
            }

            .price-p {
              font-size: 3rem;
              color: #333333;
            }
          }
        }
      }
    }

    .buying-image {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .image-box {
        width: 8.333rem;
        height: 8.333rem;
      }

      .title {
        margin: 2rem 0;
      }

    }

    .btn {
      width: 9.375rem;
      height: 2.604rem;
      background-color: #b1222b;
      border-color: #b1222b;
      border-radius: 0.313rem;
      font-size: 1.146rem;
      letter-spacing: 0.021rem;
      color: #ffffff;
    }
  }
</style>
